export const uninitialised = (): void => {
  throw `function uninitialised`;
};

export const uninitializedPromise = <T>(): Promise<T> => {
  return Promise.reject(new Error("Function not initialized"));
};
